module.exports = __webpack_public_path__ + "img/track.c6e0c8c6.png";